import useMarketingSettings from './useMarketingSettings';

export { useMarketingSettings };
